export const PAGE_SIZE = 50;

export const MAX_UNREAD_SIZE = 9;
